// Wellform MD brand constants
export const BRAND = {
  name: "Wellform MD",
  tagline: "Weight Loss & Wellness",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_quick-hours-1/artifacts/frd0ly1v_logo-vertical-color.jpg",
  teal: "#2aa39a",
  tealDark: "#1f837c",
  purple: "#7e57a3",
  purpleDark: "#5f3d80",
};
